import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App.jsx'

// Read disclaimerText from the DOM attribute
const appElement = document.getElementById('quick-quote-app');
const disclaimerText = appElement ? appElement.getAttribute('data-disclaimer-text') : '';
const headingText = appElement ? appElement.getAttribute('data-heading-text') : '';
const submitButtonText = appElement ? appElement.getAttribute('data-submit-button-text') : '';
const costAltText = appElement ? appElement.getAttribute('data-cost-alt-text') : '';
const jewelryTypes = appElement ? JSON.parse(appElement.getAttribute('data-jewelry-types') || '[]') : [];
const qqLink = appElement ? appElement.getAttribute('data-qq-link') : '';
const qqDesktopMode = appElement ? appElement.getAttribute('data-qq-mode') : '';

createRoot(appElement).render(
  <StrictMode>
    <App
      disclaimerText={disclaimerText}
      headingText={headingText}
      submitButtonText={submitButtonText}
      costAltText={costAltText}
      jewelryTypes={jewelryTypes}
      qqLink={qqLink}
      qqDesktopMode={qqDesktopMode}
    />
  </StrictMode>,
)
